import axios from "axios";
import { ShipCreatePayload, ShipDataType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";

export const createShipApi = async (
  shipData: ShipCreatePayload,
): Promise<ShipDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");

  const response = await axios.post<ShipDataType>(
    `${API_BASE_URL}/save-ship`,
    shipData,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
